<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <h1>{{ "billing.articles.title" | translate }}</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <section class="formButton" *ngIf="!isCreationMode">
      <form
        [formGroup]="clientSiteForm"
        *ngIf="!isLoading && clientSiteForm"
        class="formClient"
      >
        <div class="clientField">
          <app-autocomplete
            [control]="getControl('client')"
            [list]="clients"
            label="billing.articles.list.client"
          >
          </app-autocomplete>
        </div>

        <div class="siteField">
          <app-autocomplete
            *ngIf="showSites && getControl('client').value"
            [control]="getControl('site')"
            [list]="sites"
            label="billing.articles.list.site"
          >
          </app-autocomplete>
        </div>

        <div class="toggleSubcontractor" *ngIf="canShowSubcontractorToggle && getControl('site').value">
          <mat-slide-toggle
            [(ngModel)]="useSubcontractorPrices"
            [ngModelOptions]="{standalone: true}"
            (change)="onToggleSubcontractorPrices()"
            color="primary"
          >
            Afficher les prix sous-traitants
          </mat-slide-toggle>
        </div>

        <button
          *ngIf="getControl('client').value && getControl('site').value"
          type="button"
          mat-raised-button
          color="primary"
          (click)="showArticles()"
          [disabled]="clientSiteForm.invalid"
        >
          Filtrer
        </button>
      </form>

      <button
        *ngIf="getControl('site').value"
        color="primary"
        mat-raised-button
        [disabled]="isLoading"
        (click)="generateArticles(getControl('site').value)"
      >
        Générer articles
      </button>

      <button
        *ngIf="getControl('site').value"
        color="primary"
        mat-raised-button
        [disabled]="isLoading"
        (click)="showIncompleteTariffs()"
        class="showIncomplete"
      >
        Afficher les articles incomplets
      </button>

      <button
        *ngIf="getControl('site').value"
        color="primary"
        mat-raised-button
        [disabled]="isLoading"
        (click)="openIndexingDialog()"
      >
        Indexation
      </button>
    </section>

    <section class="creation-form" *ngIf="getControl('site').value">
      <button
        *ngIf="!isCreationMode"
        (click)="onEdit()"
        matTooltip="Créer un article"
        mat-mini-fab
        class="action-button"
        color="primary"
      >
        <mat-icon aria-label="Add">add</mat-icon>
      </button>
      <app-article-create
        *ngIf="isCreationMode && !editedId"
        (editFinished)="onEditFinished()"
        [site]="getControl('site').value"
        [client]="getControl('client').value"
      >
      </app-article-create>
    </section>

    <section
      [hidden]="isLoading || !articlesFormated || isCreationMode"
      class="datatable-articles"
    >
      <table
        mat-table
        [dataSource]="dataSource"
        multiTemplateDataRows
        class="mat-elevation-z8"
      >
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Nom</th>
          <td
            mat-cell
            *matCellDef="let article; let i = dataIndex"
            [attr.rowspan]="article.stepsFormated.length"
            [style.display]="article.indexStep === 0 ? '' : 'none'"
            class="stepCell"
          >
            <div *ngIf="!isArticleEdited(article)">
              {{ article.name }}
            </div>
            <div *ngIf="isArticleEdited(article)">
              <mat-form-field>
                <input
                  type="text"
                  matInput
                  [(ngModel)]="article.name"
                />
              </mat-form-field>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="sender">
          <th mat-header-cell *matHeaderCellDef>Expéditeur</th>
          <td
            mat-cell
            *matCellDef="let article; let i = dataIndex"
            [attr.rowspan]="article.stepsFormated.length"
            [style.display]="article.indexStep === 0 ? '' : 'none'"
          >
            <ng-container *ngIf="article.sender.address"
              >{{ article.sender.address.name }}
            </ng-container>
            <ng-container *ngIf="!article.sender.address"
              >{{ article.sender.otherAddress }}
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="urgency">
          <th mat-header-cell *matHeaderCellDef>Niveau d'urgence</th>
          <td
            mat-cell
            *matCellDef="let article; let i = dataIndex"
            [attr.rowspan]="article.stepsFormated.length"
            [style.display]="article.indexStep === 0 ? '' : 'none'"
          >
            {{ article.urgency.name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="step">
          <th mat-header-cell *matHeaderCellDef>Étape</th>
          <td mat-cell *matCellDef="let article" class="stepCell">
            <ng-container *ngIf="article.step.address"
              >{{ article.step.address.name }}
            </ng-container>
            <ng-container *ngIf="!article.step.address"
              >{{ article.step.otherAddress }}
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="distance">
          <th mat-header-cell *matHeaderCellDef>Distancier (km)</th>
          <td
            mat-cell
            *matCellDef="let article; let i = dataIndex"
            [attr.rowspan]="article.stepsFormated.length"
            [style.display]="article.indexStep === 0 ? '' : 'none'"
            class="stepCell"
          >
            <div *ngIf="!isArticleEdited(article)">
              {{ article.distance }}
            </div>
            <div *ngIf="isArticleEdited(article)">
              <mat-form-field class="inputNumber">
                <input
                  type="number"
                  min="0"
                  matInput
                  [(ngModel)]="article.distance"
                />
              </mat-form-field>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="isPricedPerKm">
          <th mat-header-cell *matHeaderCellDef>Prix kilométrique</th>
          <td
            mat-cell
            *matCellDef="let article; let i = dataIndex"
            [attr.rowspan]="article.stepsFormated.length"
            [style.display]="article.indexStep === 0 ? '' : 'none'"
            class="stepCell"
          >
            <mat-checkbox
              [disabled]="!isArticleEdited(article)"
              [(ngModel)]="article.isPricedPerKm"
              color="primary"
            ></mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="daysWeekDay">
          <th mat-header-cell *matHeaderCellDef>Jour</th>
          <td mat-cell *matCellDef="let article">
            <div *ngIf="!article.isEdit && article.daysWeek.dayPrice">
              {{ article.daysWeek.dayPrice }}
              <span *ngIf="article.isPricedPerKm && article.distance">
                <br />
                ({{
                  article.daysWeek.dayPrice * article.distance
                    | number: "1.2-2"
                }})
              </span>
            </div>
            <div *ngIf="article.isEdit">
              <mat-form-field class="inputNumber">
                <input
                  type="number"
                  min="0"
                  matInput
                  [(ngModel)]="article.daysWeek.dayPrice"
                />
              </mat-form-field>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="daysWeekNight">
          <th mat-header-cell *matHeaderCellDef>Nuit</th>
          <td mat-cell *matCellDef="let article">
            <div *ngIf="!article.isEdit && article.daysWeek.nightPrice">
              {{ article.daysWeek.nightPrice }}
              <span *ngIf="article.isPricedPerKm && article.distance">
                <br />
                ({{
                  article.daysWeek.nightPrice * article.distance
                    | number: "1.2-2"
                }})
              </span>
            </div>
            <div *ngIf="article.isEdit">
              <mat-form-field class="inputNumber">
                <input
                  type="number"
                  min="0"
                  matInput
                  [(ngModel)]="article.daysWeek.nightPrice"
                />
              </mat-form-field>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="saturdayDay">
          <th mat-header-cell *matHeaderCellDef>Jour</th>
          <td mat-cell *matCellDef="let article">
            <div *ngIf="!article.isEdit && article.saturday.dayPrice">
              {{ article.saturday.dayPrice }}
              <span *ngIf="article.isPricedPerKm && article.distance">
                <br />
                ({{
                  article.saturday.dayPrice * article.distance
                    | number: "1.2-2"
                }})
              </span>
            </div>
            <div *ngIf="article.isEdit">
              <mat-form-field class="inputNumber">
                <input
                  type="number"
                  min="0"
                  matInput
                  [(ngModel)]="article.saturday.dayPrice"
                />
              </mat-form-field>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="saturdayNight">
          <th mat-header-cell *matHeaderCellDef>Nuit</th>
          <td mat-cell *matCellDef="let article">
            <div *ngIf="!article.isEdit && article.saturday.nightPrice">
              {{ article.saturday.nightPrice }}
              <span *ngIf="article.isPricedPerKm && article.distance">
                <br />
                ({{
                  article.saturday.nightPrice * article.distance
                    | number: "1.2-2"
                }})
              </span>
            </div>
            <div *ngIf="article.isEdit">
              <mat-form-field class="inputNumber">
                <input
                  type="number"
                  min="0"
                  matInput
                  [(ngModel)]="article.saturday.nightPrice"
                />
              </mat-form-field>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="sundayDay">
          <th mat-header-cell *matHeaderCellDef>Jour</th>
          <td mat-cell *matCellDef="let article">
            <div *ngIf="!article.isEdit && article.sunday.dayPrice">
              {{ article.sunday.dayPrice }}
              <span *ngIf="article.isPricedPerKm && article.distance">
                <br />
                ({{
                  article.sunday.dayPrice * article.distance | number: "1.2-2"
                }})
              </span>
            </div>
            <div *ngIf="article.isEdit">
              <mat-form-field class="inputNumber">
                <input
                  type="number"
                  min="0"
                  matInput
                  [(ngModel)]="article.sunday.dayPrice"
                />
              </mat-form-field>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="sundayNight">
          <th mat-header-cell *matHeaderCellDef>Nuit</th>
          <td mat-cell *matCellDef="let article">
            <div *ngIf="!article.isEdit && article.sunday.nightPrice">
              {{ article.sunday.nightPrice }}
              <span *ngIf="article.isPricedPerKm && article.distance">
                <br />
                ({{
                  article.sunday.nightPrice * article.distance
                    | number: "1.2-2"
                }})
              </span>
            </div>
            <div *ngIf="article.isEdit">
              <mat-form-field class="inputNumber">
                <input
                  type="number"
                  min="0"
                  matInput
                  [(ngModel)]="article.sunday.nightPrice"
                />
              </mat-form-field>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th
            mat-header-cell
            *matHeaderCellDef
            [attr.colspan]="2"
            class="actionsCell"
          >
            Actions
          </th>
          <td mat-cell *matCellDef="let article">
            <ng-container *ngIf="!editedId">
              <button
                mat-icon-button
                class="action-button"
                color="primary"
                [disabled]="isLoading"
                matTooltip="Editer"
                (click)="onEditArticle(article)"
              >
                <mat-icon aria-label="Edit">edit</mat-icon>
              </button>
            </ng-container>
            <ng-container *ngIf="article.step.id === editedId">
              <button
                mat-icon-button
                class="action-button"
                color="primary"
                [disabled]="isLoading"
                matTooltip="Mettre à jour"
                (click)="onUpdate(article)"
              >
                <mat-icon aria-label="Update">check</mat-icon>
              </button>
              <button
                mat-icon-button
                class="action-button"
                color="primary"
                [disabled]="isLoading"
                matTooltip="Annuler"
                (click)="onCancel(article)"
              >
                <mat-icon aria-label="Cancel">clear</mat-icon>
              </button>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="onDelete">
          <th mat-header-cell *matHeaderCellDef class="actionsCell"></th>
          <td
            mat-cell
            *matCellDef="let article"
            [attr.rowspan]="article.stepsFormated.length"
            [style.display]="article.indexStep === 0 ? '' : 'none'"
            class="deleteCell"
          >
            <ng-container *ngIf="!editedId">
              <button
                mat-icon-button
                class="action-button"
                color="primary"
                [disabled]="isLoading"
                matTooltip="Supprimer"
                (click)="onDeleteArticle(article.id)"
              >
                <mat-icon aria-label="Edit">delete</mat-icon>
              </button>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="filterName">
          <th
            mat-header-cell
            *matHeaderCellDef
            [style.text-align]="center"
            [attr.colspan]="1"
          >
            <div class="cellTh">
              <div class="autocompleteFilter">
              </div>
            </div>
          </th>
        </ng-container>

        <ng-container matColumnDef="filterSender">
          <th
            mat-header-cell
            *matHeaderCellDef
            [style.text-align]="center"
            [attr.colspan]="1"
          >
            <div class="cellTh">
              <div class="autocompleteFilter">
                <app-autocomplete-filter
                  *ngIf="!isLoadingFilterForm && filterForm"
                  [valueWanted]="'name'"
                  [control]="filterForm.get('sender')"
                  [list]="senders"
                  (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter()"
                >
                </app-autocomplete-filter>
              </div>
            </div>
          </th>
        </ng-container>

        <ng-container matColumnDef="filterUrgency">
          <th
            mat-header-cell
            *matHeaderCellDef
            [style.text-align]="center"
            [attr.colspan]="1"
          >
            <div class="cellTh">
              <div class="autocompleteFilter">
                <app-autocomplete-filter
                  *ngIf="!isLoadingFilterForm && filterForm"
                  [valueWanted]="'name'"
                  [control]="filterForm.get('urgency')"
                  [list]="urgencyLevels"
                  (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter($event)"
                >
                </app-autocomplete-filter>
              </div>
            </div>
          </th>
        </ng-container>

        <ng-container matColumnDef="filterStep">
          <th
            mat-header-cell
            *matHeaderCellDef
            [style.text-align]="center"
            [attr.colspan]="1"
          >
            <div class="cellTh">
              <div class="autocompleteFilter">
                <app-autocomplete-filter
                  *ngIf="!isLoadingFilterForm && filterForm"
                  [valueWanted]="'name'"
                  [control]="filterForm.get('step')"
                  [list]="receivers"
                  (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter()"
                >
                </app-autocomplete-filter>
              </div>
            </div>
          </th>
        </ng-container>

        <ng-container matColumnDef="distanceHeader">
          <th mat-header-cell *matHeaderCellDef [attr.colspan]="2"></th>
        </ng-container>

        <ng-container matColumnDef="weekDays">
          <th mat-header-cell *matHeaderCellDef [attr.colspan]="2">Semaine</th>
        </ng-container>

        <ng-container matColumnDef="saturday">
          <th mat-header-cell *matHeaderCellDef [attr.colspan]="2">Samedi</th>
        </ng-container>

        <ng-container matColumnDef="sunday">
          <th
            mat-header-cell
            *matHeaderCellDef
            [attr.colspan]="2"
            class="sundayCol"
          >
            Dimanche/jours fériés
          </th>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="[
            'filterName',
            'filterSender',
            'filterUrgency',
            'filterStep',
            'distanceHeader',
            'weekDays',
            'saturday',
            'sunday',
          ]"
        ></tr>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="row"
        ></tr>
      </table>
    </section>

    <mat-spinner
      *ngIf="isLoading"
      [diameter]="35"
      color="primary"
      class="spinner"
    ></mat-spinner>
  </mat-card-content>
</mat-card>
